module.exports = __webpack_public_path__ + "assets/ec0f70d0d151688c3e7887fd9c433679.png";